<template>
  <el-carousel direction="vertical" indicator-position="outside" height="400px">
    <el-carousel-item v-bind:key="spotlight.id" v-for="spotlight in spotlights">
      <div class="spotlightSlide">
        <div class="left">
          <img :src="spotlight.imgSrc" />
        </div>
        <div class="right">
          <h1>{{ spotlight.name }}</h1>
          <p>{{ spotlight.description }}</p>
          <p>Favorite part about QPC: {{ spotlight.favPart }}</p>
          <h3>Words of advice: {{ spotlight.quote }}</h3>
        </div>
      </div>
    </el-carousel-item>
  </el-carousel>
</template>

<script>
export default {
  name: "SpotlightSlide",
  data() {
    return {
      spotlights: [
        {
          id: 1,
          name: "First Persons Name",
          imgSrc:
            "https://images.squarespace-cdn.com/content/v1/5bf84b434611a034b52113b9/1580982334108-PNIFXACTKP4LJOKGXYR6/ke17ZwdGBToddI8pDm48kFyD7pzB8zoMIVY5aiUuFlp7gQa3H78H3Y0txjaiv_0fDoOvxcdMmMKkDsyUqMSsMWxHk725yiiHCCLfrh8O1z4YTzHvnKhyp6Da-NYroOW3ZGjoBKy3azqku80C789l0jG2lbcDYBOeMi4OFSYem8DMb5PTLoEDdB05UqhYu-xbnSznFxIRsaAU-3g5IaylIg/PQC+Alums.JPG",
          description:
            "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mauris dapibus metus eget scelerisque fringilla. Aenean lobortis lobortis nisl nec hendrerit. Phasellus varius est quis lorem ullamcorper, mollis laoreet libero tristique. Maecenas id ultrices nunc. Etiam venenatis, elit vel placerat ultrices, dolor lorem euismod nunc, eu egestas tellus mi sed turpis. In vestibulum pretium lorem ut ornare. Mauris mauris odio, viverra non dignissim sit amet, commodo dapibus urna.",
          favPart:
            "The people. I was surrounded by people who wanted to make a change.",
          quote:
            "All our dreams can come true, if we have the courage to pursue them.",
        },
        {
          id: 2,
          name: "Second Persons Name",
          imgSrc:
            "https://images.squarespace-cdn.com/content/v1/5bf84b434611a034b52113b9/1580983576862-LNR7JGS4DPZKCIR4X6ED/ke17ZwdGBToddI8pDm48kApm4bZ6Mn3TiUWou3kA3bp7gQa3H78H3Y0txjaiv_0fDoOvxcdMmMKkDsyUqMSsMWxHk725yiiHCCLfrh8O1z5QPOohDIaIeljMHgDF5CVlOqpeNLcJ80NK65_fV7S1UWZaykogqWzieOupsqeSuBYug-y5Ut2InYZT1FrJD3yL-rj95DA1mjJIBxXFGHkuyQ/tedra+smile.jpg",
          description:
            "Proin aliquet turpis massa, vel sollicitudin dolor tempus eleifend. Morbi suscipit feugiat erat, id commodo turpis. Fusce fermentum dolor et turpis fermentum, id suscipit eros laoreet. Nam quis enim sit amet elit consectetur scelerisque id ut massa. Donec odio ex, cursus ut ornare quis, dictum vel quam. Sed ut gravida sapien. Donec et mauris a odio posuere placerat. Sed eu efficitur nulla, et vestibulum lacus. Sed cursus nisl purus, a volutpat magna maximus sit amet. Sed aliquet eros non lectus luctus hendrerit. Nullam dapibus auctor urna, vitae feugiat turpis suscipit non. Duis quis eros id dui rutrum malesuada. Quisque aliquet dui non hendrerit dignissim.",
          favPart:
            "The fact that the football stadium was changed into a garden. It shows how unique the school is.",
          quote: "The secret of getting ahead is getting started.",
        },
      ],
    };
  },
};
</script>

<style scoped>
.spotlightSlide {
  display: flex;
  justify-content: center;
}

img {
  width: 90%;
}

.left {
  margin-right: 50px;
  width: 50%;
}

.right {
  margin-right: 50px;
  width: 50%;
}
</style>
